import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { selectLoading, selectData } from 'shared/selectors';
import {
  downloadReportListJobDetailForPublic,
  downloadReportListJobDetailReset,
  getShareReport,
} from 'views/ProductTesting/actions';
import ShareReport from './view';

const PRODUCT_TESTING_REDUCER_KEY = 'productTestingReducer';
const ATTR_SHARE_REPORT_LIST_KEY = 'shareReportList';
const ATTR_DOWNLOAD_REPORT_LIST_JOB_DETAIL_KEY = 'reportDownloadedListJobDetail';

const mapStateToProps = (state) => {
  return {
    shareReportLoading: selectLoading(
      PRODUCT_TESTING_REDUCER_KEY,
      ATTR_SHARE_REPORT_LIST_KEY
    )(state),
    shareReportList: selectData(PRODUCT_TESTING_REDUCER_KEY, ATTR_SHARE_REPORT_LIST_KEY)(state),
    reportDownloadedListJobDetailLoading: selectLoading(
      PRODUCT_TESTING_REDUCER_KEY,
      ATTR_DOWNLOAD_REPORT_LIST_JOB_DETAIL_KEY
    )(state),
    reportDownloadedListJobDetail: selectData(
      PRODUCT_TESTING_REDUCER_KEY,
      ATTR_DOWNLOAD_REPORT_LIST_JOB_DETAIL_KEY,
      {}
    )(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getShareReport: bindActionCreators(getShareReport, dispatch),
  downloadReportListJobDetailForPublic: bindActionCreators(downloadReportListJobDetailForPublic, dispatch),
  downloadReportListJobDetailReset: bindActionCreators(downloadReportListJobDetailReset, dispatch),
});

export default withCookies(withRouter(connect(mapStateToProps, mapDispatchToProps)(ShareReport)));
